<template>
  <v-form v-model="formValid">
    <v-subheader class="font-italic font-weight-light py-1">Generale</v-subheader>
    <v-row no-gutters class="py-1">
      <v-col>
        <v-text-field
          v-model="name"
          :rules="[max255CharRule, presenceRule]"
          dense
          filled
          label="Nome Qualifica"
          hide-details="auto"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row no-gutters class="py-1">
      <v-col>
        <v-text-field
          v-model="description"
          :rules="[max255CharRule]"
          dense
          filled
          label="Descrizione Qualifica"
          hide-details="auto"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import Vue from 'vue'
import qualificationForm from '@/services/qualifications/qualification.form.js'

export default {
  name: "GeneralFormTab",
  components: {},
  data: function() {
    return {
      name: undefined,
      description: undefined,
      loadingQualification: false,
      formValid: false,
      max255CharRule: (v) => {
        if(v) {
          return v.length <= 255 || 'Al massimo 255 caratteri'
        } else {
          return true
        }
      },
      presenceRule: (v) => {
        return !!v || 'Il campo è obbligatorio'
      },
    };
  },
  props: {
    bus: {
      type: Object,
      default: function() {
        return new Vue()
      }
    }
  },
  mounted: function() {
    this.handleObjectChanges(qualificationForm.qualification)

    var self = this
    qualificationForm.on('update', function(data) {
      self.handleObjectChanges(data.qualification)
    })
  },
  methods: {
    fields() {
      return ['name', 'description']
    },
    handleObjectChanges(qualification) {
      const fields = this.fields()
      const newValKeys = Object.keys(qualification)

      for(let i = 0; i < fields.length; i++) {
        const field = fields[i]
        if(newValKeys.includes(field) && qualification[field] != this[field]) {
          this[field] = qualification[field]
        }
      }
    },
  },
  watch: {
    formValid(newVal) {
      this.$emit('update:valid', newVal)
      if(this.bus) {
        this.bus.$emit('update:valid', newVal)
      }
      qualificationForm.setValid(newVal)
    },
    name(newVal) {
      qualificationForm.updateField('name', newVal)
    },
    description(newVal) {
      qualificationForm.updateField('description', newVal)
    },
  }
};
</script>